var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { LoaderDialog } from './styles';
import Loader from 'react-loader';
var LoaderOverlay = /** @class */ (function (_super) {
    __extends(LoaderOverlay, _super);
    function LoaderOverlay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoaderOverlay.prototype.render = function () {
        var isLoading = this.props.isLoading;
        return (React.createElement(LoaderDialog, { open: isLoading, disableBackdropClick: true },
            React.createElement(Loader, { loaded: false, lines: 13, length: 20, width: 7, radius: 30, corners: 1, rotate: 0, direction: 1, color: "#fff", speed: 1, trail: 60, shadow: false, hwaccel: false, className: "spinner", zIndex: 2e9, top: "50%", left: "50%", scale: 0.25, loadedClassName: "loadedContent" })));
    };
    return LoaderOverlay;
}(React.Component));
export { LoaderOverlay };
